module.exports = __webpack_public_path__ + "img/IMG_0699.57ba2e10.jpg";